(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-home-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ec-home-reviews'))customElements.define('ec-home-reviews',class extends HTMLElement{connectedCallback(){this.observer=new MutationObserver(()=>this.refresh());this.observer.observe(this,{childList:true,subtree:true});this.refresh();}refresh(){const cards=[...this.querySelectorAll('.jdgm-card[data-review-id]')];const count=new Set(cards.map(c=>c.dataset.reviewId)).size;this.classList.toggle('is-single-review',count===1);}disconnectedCallback(){this.observer?.disconnect();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-style-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ec-style-gallery')) {
    customElements.define('ec-style-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ec-style-gallery__track');
        this.previous = this.querySelector('[data-ec-gallery-prev]');
        this.next = this.querySelector('[data-ec-gallery-next]');
        this.navigation = this.querySelector('.ec-style-gallery__navigation');
        if (!this.track || !this.previous || !this.next) return;
        this.track.querySelectorAll('[data-ec-gallery-clone]').forEach(card => card.remove());
        this.cards = [...this.track.children];
        this.cards.forEach(card => {
          const clone = card.cloneNode(true);
          clone.setAttribute('data-ec-gallery-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('data-shopify-editor-block');
          this.track.appendChild(clone);
        });
        this.track.classList.add('ec-style-gallery__track--loop');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.dragging = false;
        this.frame = 0;
        this.arrowOffset = 0;
        this.position = this.track.scrollLeft;
        this.wrap = value => ((value % this.cycle) + this.cycle) % this.cycle;
        this.stop = () => {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
        };
        this.animate = now => {
          const elapsed = Math.min(now - this.lastFrame, 48);
          this.lastFrame = now;
          const arrowStep = Math.abs(this.arrowOffset) < .25 ? this.arrowOffset : this.arrowOffset * Math.min(1, elapsed / 80);
          this.arrowOffset -= arrowStep;
          this.position = this.wrap(this.position + elapsed * .032 + arrowStep);
          this.track.scrollLeft = this.position;
          this.frame = requestAnimationFrame(this.animate);
        };
        this.syncPlayback = () => {
          if (this.dataset.autoplay !== 'true' || this.reducedMotion.matches || !this.inView || this.dragging || document.hidden || !this.cycle) {
            this.stop();
          } else if (!this.frame) {
            this.position = this.wrap(this.track.scrollLeft);
            this.lastFrame = performance.now();
            this.frame = requestAnimationFrame(this.animate);
          }
        };
        this.refresh = () => {
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          this.step = this.cards[0].getBoundingClientRect().width + gap;
          this.cycle = this.step * this.cards.length;
          this.navigation.hidden = this.cards.length < 2;
          this.previous.disabled = this.cards.length < 2;
          this.next.disabled = this.cards.length < 2;
          this.position = this.wrap(this.track.scrollLeft);
          this.track.scrollLeft = this.position;
          this.syncPlayback();
        };
        this.move = direction => {
          if (this.frame) this.arrowOffset += direction * this.step;
          else {
            this.position = this.wrap(this.track.scrollLeft + direction * this.step);
            this.track.scrollLeft = this.position;
          }
        };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          if (!this.frame && this.cycle) {
            this.position = this.wrap(this.track.scrollLeft);
            if (this.track.scrollLeft >= this.cycle) this.track.scrollLeft = this.position;
          }
        }, { ...options, passive: true });
        this.track.addEventListener('pointerdown', () => {
          this.dragging = true;
          this.arrowOffset = 0;
          this.stop();
        }, { ...options, passive: true });
        const finishDrag = () => {
          if (this.dragging) {
            this.dragging = false;
            this.position = this.wrap(this.track.scrollLeft);
            this.syncPlayback();
          }
        };
        window.addEventListener('pointerup', finishDrag, options);
        window.addEventListener('pointercancel', finishDrag, options);
        this.track.addEventListener('wheel', event => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey) {
            event.preventDefault();
            this.position = this.wrap(this.track.scrollLeft + (event.deltaX || event.deltaY));
            this.track.scrollLeft = this.position;
          }
        }, { ...options, passive: false });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        document.addEventListener('visibilitychange', this.syncPlayback, options);
        this.reducedMotion.addEventListener('change', this.syncPlayback, options);
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: .05 });
        this.intersectionObserver.observe(this);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.stop?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
